import useApi from "../useApi";


const useProfileBoostService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'get',
      'user/profile_boost/' + id,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useBookingService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, data) => {
    return api(
      'post',
      'user/profile_boost/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useProfileBoostService::userStore: ${error?.message || JSON.stringify(error)}`)},
      data
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, id, data) => {
    return api(
      'post',
      'user/profile_boost/' + id + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useProfileBoostService::userStore: ${error?.message || JSON.stringify(error)}`)},
      data
    )
  }

  const userShowCollection = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/profile_boosts',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useProfileBoostService::userShowCollection: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userPay = (callbackSuccess, callbackValidationErrors, profileBoostId, useCredits) => {
    return api(
      'post',
      'user/profile_boost/' + profileBoostId + '/pay',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useBookingService::userShow: ${error?.message || JSON.stringify(error)}`)},
      {use_credits:useCredits}
    )
  }

  return {
    objectType:'profile_boost',
    userShow,
    userStore,
    userUpdate,
    userShowCollection,
    userPay,
  }
}

export default useProfileBoostService